<template>
  <div class="row">
    <LoaderMaskComponent v-if="lyLoading" />
    <div v-else class="col_12">
      <div class="d_flex_btwn">
        <h1 class="common_title">
          <span v-if="$route.params.id">Edit Customer</span> 
          <span v-else>Create a New Customer</span>
        </h1>
        <span>
          <router-link :to="{name: 'customers'}" class="btn btn_black">Back to List</router-link>
        </span>
      </div>
      <div class="card border_none">
        <div class="card_body pl_0 pr_0">
          <div class="row">
            <div class="col_6 pr_20">
              <div :class="['form_row_inline', {'has_error': errorFor('first_name')}]">
                <label class="required">First Name</label>
                <div class="form_input">
                  <input type="text" class="form_global" v-model="customer.first_name">
                  <v-errors :errors="errorFor('first_name')"></v-errors>
                </div>
              </div>
              <div :class="['form_row_inline', {'has_error': errorFor('email')}]">
                <label class="required">Email</label>
                <div class="form_input">
                  <input type="email" class="form_global" v-model="customer.email">
                  <v-errors :errors="errorFor('email')"></v-errors>
                </div>
              </div>
              <div :class="['form_row_inline', {'has_error': errorFor('company_name')}]">
                <label class="required">Company Name</label>
                <div class="form_input">
                  <input type="text" class="form_global" v-model="customer.company_name">
                  <v-errors :errors="errorFor('company_name')"></v-errors>
                </div>
              </div>
            </div>

            <div class="col_6 pl_20">
              <div :class="['form_row_inline', {'has_error': errorFor('last_name')}]">
                <label class="required">Last Name</label>
                <div class="form_input">
                  <input type="text" class="form_global" v-model="customer.last_name">
                  <v-errors :errors="errorFor('last_name')"></v-errors>
                </div>
              </div>
              <div :class="['form_row_inline', {'has_error': errorFor('password')}]">
                <label class="required">Password</label>
                <div class="form_input">
                  <input type="password" class="form_global" v-model="customer.password" autocomplete="off" placeholder="Please enter mixed character (aA1@$!%*?#&) 8 digits">
                  <v-errors :errors="errorFor('password')"></v-errors>
                </div>
              </div>
              <div :class="['form_row_inline', {'has_error': errorFor('phone')}]">
                <label class="required">Phone Number</label>
                <div class="form_input">
                  <input type="text" class="form_global" v-model="customer.phone">
                  <v-errors :errors="errorFor('phone')"></v-errors>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col_6">
              <div class="form_row_inline">
                <label></label>
                <div class="form_input ">
                    <button class="btn btn_primary" :disabled="lyLoading" @click.prevent="update" v-if="$route.params.id">Update</button>
                    <button class="btn btn_primary" :disabled="lyLoading" @click.prevent="submit" v-else>Save</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import LoaderMaskComponent from "@/components/LoaderMaskComponent.vue";

    export default {
        name: 'customer-form',
        components: {LoaderMaskComponent},
        data(){
            return {
              lyLoading: false,
              customer: {
                first_name: '',
                last_name: '',
                email: '',
                password: '',
                company_name: '',
                phone: '',
              },
            }
        },
        created() {
            if(this.$route.params.id){
              this.loadData(this.$route.params.id)
            }
        },
        methods: {
          loadData(customerId){
              this.lyLoading = true;
              this.axios.get('/customers/'+customerId)
              .then((response) => {
                let customerData = response.data.data;
                this.customer.first_name = customerData.first_name
                this.customer.last_name = customerData.last_name
                this.customer.email = customerData.email
                this.customer.company_name = customerData.company_name
                this.customer.phone = customerData.phone
              })
              .catch(() => {
                  this.showFailMsg("No customer exists!");
              })
              .finally(() => {
                  this.lyLoading = false;
              })
          },
          submit() {
              this.allErrors = null;
              this.lyLoading = true;

              let formData = new FormData()

              Object.keys(this.customer).forEach(key => {
                  formData.append(key, this.customer[key] ? this.customer[key] : '');
              })

              this.axios.post('/customers', formData)
              .then(() => {
                  this.resetForm();
                  this.showSuccessMsg("Customer Created Successfully!");
                  this.$router.push({ name: 'customers'})
              })
              .catch((err) => {
                  this.allErrors = err.response.data.errors
                  this.showFailMsg(err.response.data.message);
              })
              .finally(() => {
                  this.lyLoading = false;
              })

          },
          
          update(){
              this.allErrors = null;
              this.lyLoading = true;

              let formData = new FormData()

              formData.append('_method','PATCH')

              Object.keys(this.customer).forEach(key => {
                formData.append(key, this.customer[key] ? this.customer[key] : '');
              })

              this.axios.post('/customers/'+this.$route.params.id, formData)
              .then(() => {
                  this.showSuccessMsg("Customer Update Successfully!");
              })
              .catch((err) => {
                  this.allErrors = err.response.data.errors
              })
              .finally(() => {
                  this.lyLoading = false;
              })
          },
          resetForm(){
              this.customer = {
                first_name: '',
                last_name: '',
                email: '',
                password: '',
                company_name: '',
                phone: '',
              }
          },
        }
    }
</script>
<style scoped>
  
</style>
